////////////////////////Mobile Left SideBar//////////////////////////////////
export const mobileLeftSideBarOpen = () => {
  window.dispatchEvent(new CustomEvent("app-sidebar-open"));

  let mobileLeftSideBarWrapper = document.querySelector(
    "#mobile_left_sideBar_wrapper"
  );
  let mobileLeftSideBarInnerWrapper = document.querySelector(
    "#mobile_left_sideBar_inner_wrapper"
  );

  /////////////////////////////////////////////////////////
  let mobileRightSideBarWrapper = document.querySelector(
    "#mobile_right_sideBar_wrapper"
  );
  let mobileRightSideBarInnerWrapper = document.querySelector(
    "#mobile_right_sideBar_inner_wrapper"
  );

  if (mobileLeftSideBarWrapper) mobileLeftSideBarWrapper.style.width = "100%";
  if (mobileLeftSideBarInnerWrapper)
    mobileLeftSideBarInnerWrapper.style.marginLeft = "0";

  //////////////for closing right sidebar if open/////////////////////////////
  if (mobileRightSideBarWrapper) mobileRightSideBarWrapper.style.width = "0";
  if (mobileRightSideBarInnerWrapper)
    mobileRightSideBarInnerWrapper.style.marginRight = "-450px";
};

export const mobileLeftSideBarClose = () => {
  window.dispatchEvent(new CustomEvent("app-sidebar-close"));

  let mobileLeftSideBarWrapper = document.querySelector(
    "#mobile_left_sideBar_wrapper"
  );
  let mobileLeftSideBarInnerWrapper = document.querySelector(
    "#mobile_left_sideBar_inner_wrapper"
  );

  if (mobileLeftSideBarWrapper) mobileLeftSideBarWrapper.style.width = "0";
  if (mobileLeftSideBarInnerWrapper)
    mobileLeftSideBarInnerWrapper.style.marginLeft = "-450px";
};

////////////////////////Mobile Right SideBar//////////////////////////////////
export const mobileRightSideBarOpen = () => {
  let mobileRightSideBarWrapper = document.querySelector(
    "#mobile_right_sideBar_wrapper"
  );
  let mobileRightSideBarInnerWrapper = document.querySelector(
    "#mobile_right_sideBar_inner_wrapper"
  );

  /////////////////////////////////////////////////////////
  let mobileLeftSideBarWrapper = document.querySelector(
    "#mobile_left_sideBar_wrapper"
  );
  let mobileLeftSideBarInnerWrapper = document.querySelector(
    "#mobile_left_sideBar_inner_wrapper"
  );

  if (mobileRightSideBarWrapper) mobileRightSideBarWrapper.style.width = "100%";
  if (mobileRightSideBarInnerWrapper)
    mobileRightSideBarInnerWrapper.style.marginRight = "0";

  //////////////for closing left sidebar if open/////////////////////////////
  window.dispatchEvent(new CustomEvent("app-sidebar-close"));
  if (mobileLeftSideBarWrapper) mobileLeftSideBarWrapper.style.width = "0";
  if (mobileLeftSideBarInnerWrapper)
    mobileLeftSideBarInnerWrapper.style.marginLeft = "-450px";
};

export const mobileRightSideBarClose = () => {
  let mobileRightSideBarWrapper = document.querySelector(
    "#mobile_right_sideBar_wrapper"
  );
  let mobileRightSideBarInnerWrapper = document.querySelector(
    "#mobile_right_sideBar_inner_wrapper"
  );

  if (mobileRightSideBarWrapper) mobileRightSideBarWrapper.style.width = "0";
  if (mobileRightSideBarInnerWrapper)
    mobileRightSideBarInnerWrapper.style.marginRight = "-450px";
};
